import React, { useState, useEffect, useContext } from "react";
import {
  getAuth,
  signOut,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  sendEmailVerification,
} from "firebase/auth";
import { firebaseErrorMap } from "../config";
import md5 from "md5";
import { Link } from "react-router-dom";
import { Grid, Card, Button, Input, Dropdown, Icon } from "semantic-ui-react";
import { GlobalContext } from "../contexts";
import { api } from "../config";
import axios from "axios";

import { useToasts } from "react-toast-notifications";
import moment from "moment";

function Account() {
  const { user, userData } = useContext(GlobalContext);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    axios.get(api + "get_products").then((p) => {
      setProducts(p.data);
    });
  }, []);
  useEffect(
    () => window.history.pushState(null, "", window.location.origin),
    []
  );
  const [loadingLogout, setLoadingLogout] = useState(false);
  const [loadingVerification, setLoadingVerification] = useState(false);
  const sendEmailVerificationWrapper = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (loadingVerification) {
      return;
    }
    setLoadingVerification(true);
    try {
      console.log(user);
      await sendEmailVerification(user);
      addToast("A new verification email has been sent", {
        appearance: "success",
        autoDismiss: true,
      });
    } catch (e) {
      console.log(e.message);
      addToast(firebaseErrorMap[e.code] || e.message, { appearance: "error" });
    }
    setLoadingVerification(false);
  };
  const signUserOut = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (loadingLogout) {
      return;
    }
    setLoadingLogout(true);
    try {
      await signOut(getAuth());
      addToast("You are logged out!", {
        appearance: "success",
        autoDismiss: true,
      });
    } catch (e) {
      const message = firebaseErrorMap[e.code] || e.message;
    }
    setLoadingLogout(false);
  };

  let keysRender = null;

  const { addToast } = useToasts();

  if (userData && userData.products && userData.products.length) {
    keysRender = userData.products.map((product, index) => {
      return (
        <div key={index} className="product-key">
          <Card color="purple">
            <Card.Content>
              <Card.Header>{product.name}</Card.Header>
              {!product.isLifetime && (
                <Card.Meta
                  style={{ marginTop: 5, color: "maroon", fontWeight: "bold" }}
                >
                  Expire on:
                  {" " +
                    moment(new Date(product.endDate)).format("MMMM D, YYYY")}
                </Card.Meta>
              )}
              <Input
                style={{ marginTop: 10 }}
                action={{
                  color: "teal",
                  icon: "copy",
                  onClick: () => {
                    navigator.clipboard.writeText(product.apiKey);
                    addToast("Copied to clipboard!", {
                      appearance: "success",
                      autoDismiss: true,
                    });
                  },
                }}
                placeholder="API KEY"
                value={product.apiKey}
              />
              {/* <Grid
                columns={2}
                centered
                style={{ marginTop: 10, marginBottom: 10 }}
              >
                <Button size="mini" basic color="orange">
                  RE-GENERATE
                </Button>
              </Grid> */}
            </Card.Content>
            <Card.Meta style={{ marginBottom: 10 }}>
              <Button.Group size="mini">
                <Button
                  primary
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    window.open(product.downloadUrl+"?key="+product.apiKey);
                  }}
                >
                  Access
                </Button>
                <Button.Or />
                <Button
                  positive
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    window.open(product.tutorialUrl+"?key="+product.apiKey);
                  }}
                >
                  Tutorial
                </Button>
              </Button.Group>
            </Card.Meta>
          </Card>
        </div>
      );
    });
  } else keysRender = <div>No purchased products available</div>;

  let productRender = null;
  productRender = products
    .filter(
      ({ key }) =>
        (userData &&
          userData.products &&
          userData.products.length &&
          !userData.products.find((p) => p.key === key)) ||
        !userData ||
        !userData.products ||
        !userData.products.length
    )
    .map((product, index) => (
      <Grid.Column key={index} className="product-item">
        <Link disabled to={"/checkout?pid=" + product.key}>
          <Card disabled color="orange" style={{ margin: "0 auto" }}>
            <Card.Content>
              <Card.Header>{product.name}</Card.Header>
              <Icon name="shopping cart" color="orange" />
            </Card.Content>
            <Card.Content extra>From ${product.month_1_price}</Card.Content>
            <Card.Content>
              <Button.Group size="mini">
                <Button
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    window.open(product.detailUrl);
                  }}
                  style={{ display: "inline-block" }}
                  positive
                >
                  View
                </Button>

                <Button.Or />
                <Link disabled to={"/checkout?pid=" + product.key}>
                  <Button color="orange" style={{ display: "inline-block" }}>
                    Buy now
                  </Button>
                </Link>
              </Button.Group>
            </Card.Content>
          </Card>
        </Link>
      </Grid.Column>
    ));
  productRender.length === 0 &&
    (productRender = <div>No products available</div>);
  const handleChange = (event, callback) => {
    callback(event.target.value);
  };

  return (
    <div className="container account">
      <div style={{ fontSize: 50, lineHeight: "52px", marginTop: 15 }}>
        THEAPP KEY CENTER
      </div>
      <Card fluid>
        <Grid doubling columns={2} divided>
          <Grid.Column width={8}>
            <div className="account-section">
              <h3 style={{ color: "rgb(23 58 122)", marginBottom: 10 }}>
                WELCOME,{" "}
                {userData &&
                  userData.firstName &&
                  userData.firstName.toUpperCase()}
              </h3>
              <div className="user-email">{user.email}</div>
              <Grid
                columns={2}
                centered
                style={{ marginTop: 10, marginBottom: 10 }}
              >
                {!user.emailVerified && (
                  <Button
                    size="mini"
                    basic
                    style={{ marginRight: 10 }}
                    color="blue"
                    loading={loadingVerification}
                    onClick={sendEmailVerificationWrapper}
                  >
                    RESEND VERIFICATION EMAIL
                  </Button>
                )}

                <Button
                  size="mini"
                  loading={loadingLogout}
                  onClick={signUserOut}
                  basic
                  color="orange"
                >
                  LOGOUT
                </Button>
              </Grid>
              <hr style={{ marginTop: 20 }} />
              <h3
                style={{
                  color: "rgb(23 58 122)",
                  marginBottom: 7,
                  marginTop: 17,
                }}
              >
                API KEYS
              </h3>
              <div className="key-section">
                <Grid
                  doubling
                  style={{ padding: "10px 50px" }}
                  centered
                  columns={1}
                >
                  {user.emailVerified && keysRender}
                  {!user.emailVerified &&
                    "Please verify your email to use this feature!"}
                </Grid>
              </div>
            </div>
          </Grid.Column>
          <Grid.Column>
            <div className="account-section">
              <h3 style={{ color: "rgb(23 58 122)" }}>
                CHOOSE YOUR NEXT PRODUCT
              </h3>
              <Grid
                doubling
                style={{
                  padding: "10px 50px",
                  overflow: "auto",
                }}
                centered
                columns={1}
              >
                {productRender}
              </Grid>
            </div>
          </Grid.Column>
        </Grid>
      </Card>
    </div>
  );
}
export default Account;
